// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"349023ca","453":"51f5d0f8","732":"a9f795ad"}[chunkId] + ".chunk.js";
};